import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import apiClient from "../api/axios";
import { RECIPE_BY_ID_URL } from "../util/constants";
import { getApiParams, getImageUrl } from "../util/helper";

const RecipeDetail = () => {
  const { id } = useParams();
  const [recipe, setRecipe] = useState(null);

  useEffect(() => {
    apiClient
      .get(RECIPE_BY_ID_URL.replace("{id}", id), getApiParams())
      .then((res) => {
        setRecipe(res.recipe);
      })
      .catch((error) => console.error(error));
  }, [id]);

  if (recipe === null) {
    return <div></div>;
  }

  return (
    <div className="px-4 sm:px-16 py-8 w-[97%] mx-auto">
      <h1 className="text-2xl sm:text-4xl mb-5">{recipe.label}</h1>
      <img
        src={getImageUrl(recipe.images)}
        alt={recipe.label}
        className="w-full sm:w-[80%] object-cover aspect-[1/0.57] rounded-lg mb-10"
      />
      <div className="my-5 flex flex-col text-left divide sm:flex-row sm:divide-x-2 mb-10">
        <div className="sm:pr-10">
          <p className="font-thin text-xs">PREP TIME</p>
          <p>{recipe.totalTime} MIN</p>
        </div>
        <div className="mt-2 sm:px-10 sm:mt-0">
          <p className="font-thin text-xs">DISH TYPE</p>
          <p className="capitalize">{recipe.dishType[0]}</p>
        </div>
        <div className="mt-2 sm:px-10 sm:mt-0">
          <p className="font-thin text-xs">MEAL TYPE</p>
          <p className="capitalize">{recipe.mealType[0]}</p>
        </div>
        <div className="mt-2 sm:px-10 sm:mt-0">
          <p className="font-thin text-xs">CUISINE</p>
          <p className="capitalize">{recipe.cuisineType[0]}</p>
        </div>
        <div className="mt-2 sm:px-10 sm:mt-0">
          <p className="font-thin text-xs">SOURCE</p>
          <Link to={recipe.url} target="_blank">
            <p className="capitalize">
              <FaExternalLinkAlt className="mt-0.5" />
            </p>
          </Link>
        </div>
      </div>
      <hr />
      <div className="flex flex-col-reverse sm:flex-row-reverse justify-between mt-10">
        <div className="space-y-4 mt-4 sm:mt-0 sm:w-3/6">
          <h2 className="font-semibold text-2xl mt-8 sm:mt-2">Ingredients</h2>
          {recipe.ingredients &&
            recipe.ingredients.map((ingredient, index) => {
              return (
                <div key={index} className=" cursor-pointer">
                  <p className="flex items-start gap-2">
                    <IoMdCheckmarkCircleOutline
                      size={20}
                      className="flex flex-shrink-0 mt-0.5"
                    />{" "}
                    {ingredient.text}
                  </p>
                </div>
              );
            })}
        </div>

        <div className="bg-gray-100 sm:w-[35%] flex flex-col items-center pb-2">
          <h2 className="font-semibold text-2xl p-2">Nutrition Facts</h2>
          <table className="w-11/12 sm:w-10/12">
            <tbody>
              {Object.values(recipe.totalNutrients)
                .slice(0, 10)
                .map((nutrient) => (
                  <tr
                    key={nutrient.label}
                    className="border-b border-gray-300 flex justify-between last:border-0"
                  >
                    <td className="py-1 font-thin">{nutrient.label}</td>
                    <td>
                      {nutrient.quantity.toFixed(2)} {nutrient.unit}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RecipeDetail;
